import React from 'react';
import getClassNames from '../../Utils/getClassNames';
import InformationPopover from './InformationPopover';

const Select = (props) => {
    const handleOnChange = (e) => {
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    };

    return (
        <div className="row align-items-center">
            <div className="col">
                {props.label && <label className={props.labelClassName} htmlFor={props.id}>{props.label}</label>}
                <select id={props.id}
                    className={getClassNames('form-control', props.className)}
                    value={props.value}
                    onChange={handleOnChange}
                    name={props.name || props.id}>
                    {props.children}
                </select>
            </div>
            {props.information && (
                <div className={getClassNames('col-auto', props.label && 'mt-4')}>
                    <InformationPopover content={props.information} />
                </div>
            )}
        </div>
    )
};

export default Select;